import { render, staticRenderFns } from "./FaceRecognitionActivation.vue?vue&type=template&id=5129a2f1"
import script from "./FaceRecognitionActivation.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports